export const appTypo = {
  font: {
    kintoSans: "kinto-sans",
    notoJp: "Noto Sans JP, sans-serif",
    roboto: "Roboto, sans-serif",
    inter: "Inter, Noto Sans JP, sans-serif",
    geist: "Geist, Inter, Noto Sans JP, sans-serif",
  },
} as const;
